import React, { useState, useEffect, useCallback } from "react";
import { PlusOutlined, MinusOutlined, DeleteOutlined } from "@ant-design/icons";
import { TablePlug, NumberSelector } from "./Styled";
import { apiGetCarts, apiPutCarts, apiGetActivityContent } from "api/api";
import { convertTimeStamp } from "utility/functions/convertTimestamp";
import { useSelector, useDispatch } from "react-redux";
import { updateCartsAmount } from "store/slice/index";
import { message } from "antd";

const ChartTable = ({ setCartsAmount }) => {
  const dispatch = useDispatch();

  const [isLoading, setIsLoading] = useState(false);
  const [tableData, setTableData] = useState([]);

  const open = useSelector((state) => state.charts.isChartOpen);

  const isLogin =
    sessionStorage._skyFilm_t && sessionStorage._skyFilm_t.length > 0;

  const normal = "票券類型：一般票種 Ticket Type: General Admission";
  const pr = "票券類型：免費票種 Ticket Type: Free Admission";

  // 取得購物車資料
  const fetchData = useCallback(async () => {
    setIsLoading(true);
    try {
      let details = [];
      if (isLogin) {
        const res = await apiGetCarts();
        details = res.data.content.details;
      } else {
        details = JSON.parse(localStorage.getItem("carts")) || [];
      }
      setTableData(details);
    } catch (err) {
      console.log("error", err);
    } finally {
      setIsLoading(false);
    }
  }, [isLogin]);

  useEffect(() => {
    fetchData();
  }, [open, fetchData]);

  useEffect(() => {
    dispatch(updateCartsAmount(tableData.length));
  }, [tableData, dispatch]);

  useEffect(() => {
    setCartsAmount(tableData.length);
  }, [tableData, setCartsAmount]);

  // 更新購物車資料
  const updatedData = async (data = tableData) => {
    setIsLoading(true);
    try {
      if (isLogin) {
        await apiPutCarts(data);
        fetchData();
      } else {
        localStorage.setItem("carts", JSON.stringify(data));
        setTableData(data);
      }
    } catch (err) {
      console.log("error", err);
    } finally {
      setIsLoading(false);
    }
  };

  const columns = [
    {
      title: "產品 Item",
      dataIndex: "name",
      key: "name",
      render: (text, record, index) => {
        return (
          <>
            <p className="mb-2">{record.groupTitle}</p>
            <p className="mb-2">{record.title}</p>
            <p className="text-SKF-G-002 text-14">{`${convertTimeStamp(
              record.startDateTime,
              "MM/DD ddd - HH:mm"
            )}（opens at ${convertTimeStamp(
              record.admissionStartDateTime,
              "HH:mm"
            )}）`}</p>
            <p>NT${record?.price}</p>
            <p className="text-SKF-G-002 text-14">
              {record?.type === 1 ? normal : pr}
            </p>
            <NumberSelector
              controls={false}
              min={1}
              max={10}
              value={record?.amount}
              readOnly={true}
              className="mt-5 w-1/2 md:w-1/6"
              addonBefore={
                <MinusOutlined
                  onClick={() => calculate(record, "minus")}
                  className="text-white "
                />
              }
              addonAfter={
                <PlusOutlined
                  onClick={() => calculate(record, "plus")}
                  className="text-white "
                />
              }
            />
            <DeleteOutlined
              className="mt-5 pl-2 text-2xl"
              style={{
                lineHeight: "32px",
                height: "32px",
              }}
              onClick={() => handleDelete(record)}
            />
          </>
        );
      },
    },
    {
      title: "總計 Subtotal",
      dataIndex: "total",
      key: "total",
      align: "right",
      render: (text, record) => {
        return <p className="m-0">NT${record?.amount * record?.price}</p>;
      },
    },
  ];

  const handleDelete = (record) => {
    const filterData = tableData.filter(
      (item) => item.sourceId !== record.sourceId
    );
    updatedData(filterData);
  };

  const calculate = async (record, type) => {
    console.log("record", record, type);

    let maxQuantity = 10; // 預設最大數量，如果無法取得實際庫存

    try {
      if (record.activityId) {
        const res = await apiGetActivityContent({ id: record.activityId });
        const targetTicket = res.data.content.tickets.find(
          (ticket) => ticket.id === record.sourceId
        );

        if (targetTicket) {
          maxQuantity = targetTicket.remainQuantity;
        }
      }
    } catch (error) {
      console.error(
        "Error fetching activity content, skipping stock check",
        error
      );
    }

    const newTableData = tableData.map((item) => {
      if (item?.sourceId === record?.sourceId) {
        let newAmount = item.amount;
        if (type === "plus") {
          if (item.amount + 1 > maxQuantity) {
            message.error("票券數量餘額不足");
            newAmount = maxQuantity;
          } else {
            newAmount = item.amount + 1;
          }
        } else if (type === "minus") {
          newAmount = item.amount > 1 ? item.amount - 1 : 1;
        }
        return { ...item, amount: newAmount };
      }
      return item;
    });

    setTableData(newTableData);
    updatedData(newTableData); // 傳入最新資料
  };

  return (
    <TablePlug
      bordered={false}
      columns={columns}
      dataSource={tableData}
      pagination={false}
      loading={isLoading}
      className="border-none bg-SKF-G-004 [&_.ant-table-tbody>tr.ant-table-placeholder]:bg-transparent [&_.ant-empty-description]:text-white"
      summary={(pageData) => {
        let ttl = 0;
        pageData.forEach(({ price, amount }) => {
          ttl += price * amount;
        });
        return (
          <>
            <TablePlug.Summary.Row className="bg-SKF-G-004 text-white">
              <TablePlug.Summary.Cell index={0}>
                <h4>總計</h4>
              </TablePlug.Summary.Cell>
              <TablePlug.Summary.Cell index={1} colSpan={2}>
                <h4>NT${ttl}</h4>
              </TablePlug.Summary.Cell>
            </TablePlug.Summary.Row>
          </>
        );
      }}
    ></TablePlug>
  );
};

export default ChartTable;
